import React, { memo } from 'react';

import SendTestInputView from './SendTestInputView';
import SendTestResults from './SendTestResults';
import SendingStatus from './SendingStatus';

const PHASE = {
  INPUT: 'input',
  SENDING: 'sending',
  RESULTS: 'results',
};

/**
 * Modal-body dispatcher for the Send Test dialog — picks one of the three
 * phase views (input / sending / results) based on the `phase` prop.
 *
 * Props
 *   phase:   'input' | 'sending' | 'results'
 *   results: object | null — passed through to SendTestResults when phase === 'results'
 *   …input props — passed through to SendTestInputView when phase === 'input'
 *     (hasCampaigns, brazeRecipients, onBrazeRecipientsChange)
 */
const SendTestBody = ({ phase, results, ...inputProps }) => {
  if (phase === PHASE.SENDING) return <SendingStatus />;
  if (phase === PHASE.RESULTS) return <SendTestResults results={results} />;

  return <SendTestInputView {...inputProps} />;
};

export default memo(SendTestBody);
